import { useEffect } from "react";

export const useScrollToTop = ({ pathname }: { pathname: string }) => {

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
    }, [pathname]);
};

